import {
  createRouter,
  createWebHistory,
  RouterOptions,
  RouteRecordRaw,
} from 'vue-router';

import DefaultLayout from '@/layouts/DefaultLayout.vue';

import base from './modules/base';
import documents from './modules/documents';
import onboarding from './modules/onboarding';
import pricing from './modules/pricing';
import settings from './modules/settings';

const routes: RouteRecordRaw[] = ([] as RouteRecordRaw[]).concat(
  base,
  documents,
  onboarding,
  pricing,
  settings
);

routes.push({
  path: '/:pathMatch(.*)*',
  component: DefaultLayout,
  children: [
    {
      path: '',
      name: 'NotFound',
      component: () =>
        import(/* webpackChunkName: "not-found" */ '@/views/NotFound.vue'),
    },
  ],
});

const options: RouterOptions = {
  routes,
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior() {
    return { top: 0 };
  },
};

export const router = createRouter(options);

export const createRouterFn = () => {
  return createRouter(options);
};
